import React from "react";
import { Card, CardContent, Typography, Grid } from "@mui/material";

interface DataRow {
  label: string;
  value: string | number | null | undefined;
}

interface DataRowsDisplayProps {
  title?: string;
  rows: DataRow[];
  maxWidth?: number;
}

export const DataRowsDisplay: React.FC<DataRowsDisplayProps> = ({
  title,
  rows,
  maxWidth = 600,
}) => {
  const filteredRows = rows.filter(
    (row) => row.value !== undefined && row.value !== null && row.value !== ""
  );

  return (
    <Card sx={{ maxWidth, margin: "auto", padding: 2, boxShadow: 3 }}>
      <CardContent>
        {title && (
          <Typography variant="h5" gutterBottom>
            {title}
          </Typography>
        )}
        <Grid container spacing={2}>
          {filteredRows.map((row, index) => (
            <DataRowItem key={index} label={row.label} value={row.value} />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

interface DataRowItemProps {
  label: string;
  value: string | number;
}

const DataRowItem: React.FC<DataRowItemProps> = ({ label, value }) => (
  <Grid item xs={12}>
    <Typography variant="body1">
      <strong>{label}:</strong> {value}
    </Typography>
  </Grid>
);
